





































































































import { Component, Watch } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import CustomersService from '@/api/CustomersService';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { formatTotalAndPendingCoins } from '@/utils/coinsHelper';

@Component({
  components: {
    RowsTable,
    TextInput,
    ContextMenu,
    ContentContainer,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    TableCard,
    Typography
  }
})
export default class customerList extends BasePagination {
  constructor() {
    super();
  }
  service: CustomersService = new CustomersService();
  customers: List = new List([], []);
  searchableFields = 'searchableFields=c.name';
  keyOrder: string[] = [];
  loading = false;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  @Watch('isLoading')
  showFullLoadingOnMobile() {
    if (this.isMobileDevice && this.isLoading) {
      this.$showLoaderWithLocker();

      return;
    }

    this.$hideLoader();
  }

  @Watch('getFlags')
  onChange() {
    this.assignHeader();
  }

  mounted() {
    this.assignHeader();
  }

  assignHeader() {
    const { verifyFlag, flagKeys, keyOrder } = this;

    keyOrder.push('picture');
    keyOrder.push('name');
    keyOrder.push('spent');
    if (verifyFlag(flagKeys.customerListTotalRewards)) keyOrder.push('reward');
    keyOrder.push('Coins');
    if (verifyFlag(flagKeys.customerListTotalVisits)) keyOrder.push('visits');
    if (verifyFlag(flagKeys.customerListLastSeen)) keyOrder.push('last_seen');
    keyOrder.push('slot:options');

    const header = [];
    header.push(new HeaderList(`Picture`, 'none', '12px'));
    header.push(new HeaderList(`Customer name`, 'name', '12px 32px 12px 12px'));
    header.push(new HeaderList(`Total spent`, 'totalSpent'));
    header.push(new HeaderList(`Total Coins`, 'availableCoins'));
    header.push(new HeaderList(`Last visit`, 'lastSeen'));
    header.push(new HeaderList(``, 'none', '12px'));
    this.customers.header = header;
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      disabledBackdropClick: true,
      component: 'customerDetails',
      data: event,
      secondaryStyle: true
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (clearList) {
      this.resetPagination();
      this.customers.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems) return;

    this.isLoading = true;
    this.refreshing = true;

    this.service
      .getCustomers({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query
      })
      .then((response: any) => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.customers.list = this.addRowsCustomers(items);
          this.isLoading = false;
        } else {
          // refresh page and add items
          this.customers.list = this.customers.list.concat(
            this.addRowsCustomers(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .finally(() => {
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  addRowsCustomers(customersList: any[]): any[] {
    let rows: any[] = [];
    customersList.forEach((CustomerRow: any) => {
      const pathImage = JSON.parse(CustomerRow.image_publicPath);

      const getPicture = () => {
        if (pathImage) {
          return pathImage.small;
        }

        if (CustomerRow.customer_name) {
          return `
            ${CustomerRow.customer_name[0]}${CustomerRow.customer_lastname[0]}
          `;
        }

        return '';
      };

      rows.push({
        name: `${CustomerRow.customer_name} ${CustomerRow.customer_lastname}`,
        picture: getPicture(),
        spent: `${this.businessCurrency}${treatValue(CustomerRow.totalSpent) ||
          '0'}`,
        reward: treatValue(CustomerRow.totalRewards) || '0',
        coins: treatValue(CustomerRow.availableCoins) || '0',
        totalCoins: formatTotalAndPendingCoins(
          treatValue(CustomerRow.availableCoins) || '0',
          treatValue(CustomerRow.pendingCoins) || '0'
        ),
        visits: CustomerRow.totalVisits || '0',
        id: CustomerRow.customer_id,
        last_seen: DateUtils.formatISODate(CustomerRow.lastSeen),
        joined: DateUtils.formatISOLongDate(CustomerRow.createdAt, false, true)
      });
    });
    return rows;
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  created() {
    eventBus.$on('reloadCustomers', this.reloadList);
  }

  beforeDestroy() {
    eventBus.$off('reloadCustomers', this.reloadList);
  }
}
